exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-list-card[data-v-62f69750]{margin-bottom:10px}.detail-list-card-title[data-v-62f69750]{line-height:26px;margin-bottom:15px;font-size:22px}.print-container[data-v-62f69750]{cursor:pointer;padding:4px;display:flex;background-color:#f4f4f4;width:24px;float:right}.print-container img[data-v-62f69750]{margin:auto}.height[data-v-62f69750]{height:26px}span.title[data-v-62f69750]{color:grey}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62f69750","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DetailListCard.vue
// module id = 1083
// module chunks = 0